import { Component, input, output } from '@angular/core';
import { TExportTypeTranslation } from 'src/app/project/modules/exports/point-export-modal/export-types';

@Component({
  selector: 'pp-select-categorised-dropdown-item',
  templateUrl: './select-categorised-dropdown-item.component.html',
  styleUrls: ['./select-categorised-dropdown-item.component.scss'],
  standalone: false,
})
export class SelectCategorisedDropdownItemComponent {
  ppItem = input<TExportTypeTranslation>();
  ppIsSelected = input<boolean>(false);
  onClick = output();

  handleOnClick(): void {
    this.onClick.emit();
  }
}
